import api from "../api/api";

import API_URL from "../api/url";
import axios from "axios";

const NotificationService = {
  notificationList: (id , values) =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getNotification}${id ? "?id=" + id : ""}`, {
    params: {
    
      page: values?.page,
      search: values?.search,
      limit: 10, 
    }
  }
    ),
  deleteNotification: (id) =>
    api.get(`${API_URL.BASEURL}${API_URL.deleteNotification}?id=${id}`),
  updateNotification: (id) =>
    api.get(`${API_URL.BASEURL}${API_URL.updateNotification}?id=${id}`),
};

export default NotificationService;
